import { render, staticRenderFns } from "./WidgetCarouselPreview.vue?vue&type=template&id=db6fc7f2&scoped=true"
import script from "./WidgetCarouselPreview.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselPreview.vue?vue&type=style&index=0&id=db6fc7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6fc7f2",
  null
  
)

export default component.exports